import React, { useEffect, useState } from "react";

import { Select } from "antd";
import {
  getIntakeBasedOnCourses,
  getIntakes,
} from "../../HttpRequest/searchcalls";

const IntakeEducation = ({
  className,
  placeholder,
  Course,
  Country,
  University,
  userdata,
  setuserdata,
}) => {
  const [intakeinput, setintakeinput] = useState();

  const [selectintake, setselectintake] = useState();

  const onChange = (value) => {
    console.log(`selected ${value}`);
    console.log(`selected ${value}`);
    setuserdata({
      ...userdata,
      intake: value,
    });
    setselectintake(value);
  };

  useEffect(() => {
    console.log(
      "selected course  intake--->",
      Course,
      Country,
      "skfmlf",
      University
    );
    if (
      Course !== undefined &&
      Country !== undefined &&
      University !== undefined
    ) {
      getIntakes(Course, University, Country).then((response) => {
        console.log("intake responce-->", response[0]);

        setintakeinput(response[0]);
        setselectintake(null);
      });
    } else if (Course) {
      getIntakeBasedOnCourses(Course).then((response) => {
        console.log("intake responce-->", response);
        setintakeinput(response);
        setselectintake(null);
      });
    }
  }, [Course, Country, University]);
  const setIntakes = [
    { key: "Fall", value: "Fall" },
    { key: "Spring", value: "Spring" },
    { key: "Summer", value: "Summer" },
    { key: "Jan", value: "Jan" },
    { key: "Feb", value: "Feb" },
    { key: "Mar", value: "Mar" },
    { key: "Apr", value: "Apr" },
    { key: "May", value: "May" },
    { key: "June", value: "June" },
    { key: "July", value: "July" },
    { key: "Aug", value: "Aug" },
    { key: "Sep", value: "Sep" },
    { key: "Oct", value: "Oct" },
    { key: "Nov", value: "Nov" },
    { key: "Dec", value: "Dec" },
  ];
  const [selectedOption, setSelectedOption] = useState("");

  const onSearch = (value) => {
    console.log("search:", value);
  };
  // const handlechange = (value, option) => {
  //     // Use the selected value and option as needed
  //     console.log('Selected Value:', value);
  //     console.log('Selected Option:', option.label);

  //     // Update your state or perform other actions
  //     setcourseName((prevCourseName) => ({
  //       ...prevCourseName,
  //       course: value,
  //     }));
  //     localStorage.setItem("course", option.label)
  //   };

  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase());
  return (
    <Select
      className={className}
      name="intakes"
      showSearch
      placeholder="Intakes"
      value={selectintake}
      onChange={onChange}
      style={{
        // width: '100%',
        width: "200px",
        border: "none",
        fontSize: "1.1rem",
        border:'none',
        fontWeight: "500",
        backgroundColor: "transparent",
        
      }}
      onBlur={(e) => {
        if (!e.target.value) {
          setSelectedOption("");
        }
      }}
      filterOption={(input, option) =>
        option.children &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {selectedOption === "" && (
        <option value="" disabled hidden>
          Intake
        </option>
      )}

      {setIntakes.map((intakeOption) => (
        <option key={intakeOption.key} value={intakeOption.value}>
          {intakeOption.value}
        </option>
      ))}
    </Select>

    // <Select
    //   showSearch
    //   bordered={false}
    //   placeholder={placeholder}
    //   optionFilterProp="children"
    //   className={className}
    //   onChange={onChange}
    //   onSearch={onSearch}
    //   filterOption={filterOption}

    //   style={{
    //     // width: '100%',
    //     width: '200px',
    //     border: 'none',
    //     fontSize: '1.1rem',
    //     fontWeight: '500',

    //   }}
    //   // options={intakeinput}
    //   options={[
    //     {key: 'Fall', value: 'Fall'},
    //     {key: 'Spring', value: 'Spring'},
    //     {key: 'Summer', value: 'Summer'},
    //     {key: 'Jan', value: 'Jan'},
    //     {key: 'Feb', value: 'Feb'},
    //     {key: 'Mar', value: 'Mar'},
    //     {key: 'Apr', value: 'Apr'},
    //     {key: 'May', value: 'May'},
    //     {key: 'June', value: 'June'},
    //     {key: 'July', value: 'July'},
    //     {key: 'Aug', value: 'Aug'},
    //     {key: 'Sep', value: 'Sep'},
    //     {key: 'Oct', value: 'Oct'},
    //     {key: 'Nov', value: 'Nov'},
    //     {key: 'Dec', value: 'Dec'}
    //   ]}
    //   value={selectintake}
    // />
  );
};

export default IntakeEducation;
